// extracted by mini-css-extract-plugin
export var buttons = "social-module--buttons--296f8";
export var card = "social-module--card--1909b";
export var dark = "social-module--dark--4d03c";
export var light = "social-module--light--6d7ee";
export var social = "social-module--social--8a6bf";
export var socialCardWrapper = "social-module--socialCardWrapper--54a87";
export var title = "social-module--title--2aba4";
export var wrapper = "social-module--wrapper--58bbb";